/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { BPay } from "./BPay";
import { Card } from "./Card";
import { CreditCard } from "./CreditCard";
import { Psp } from "./Psp";
import { Satispay } from "./Satispay";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum TypeEnum {
  "CREDIT_CARD" = "CREDIT_CARD",

  "BANK_ACCOUNT" = "BANK_ACCOUNT",

  "EXTERNAL_PS" = "EXTERNAL_PS",

  "PAYPAL" = "PAYPAL"
}

// required attributes
const WalletR = t.interface({});

// optional attributes
const WalletO = t.partial({
  bPay: BPay,

  bancomatCard: Card,

  buyerBankName: t.string,

  creditCard: CreditCard,

  favourite: t.boolean,

  idBuyerBank: t.Integer,

  idPagamentoFromEC: t.string,

  idPsp: t.Integer,

  idWallet: t.Integer,

  isPspToIgnore: t.boolean,

  jiffyCellphoneNumber: t.string,

  lastUsage: UTCISODateFromString,

  matchedPsp: t.boolean,

  onboardingChannel: t.string,

  psp: Psp,

  pspEditable: t.boolean,

  pspListNotOnUs: t.readonlyArray(Psp, "array of Psp"),

  registeredNexi: t.boolean,

  satispay: Satispay,

  saved: t.boolean,

  services: t.readonlyArray(t.string, "array of string"),

  type: enumType<TypeEnum>(TypeEnum, "type")
});

export const Wallet = t.intersection([WalletR, WalletO], "Wallet");

export type Wallet = t.TypeOf<typeof Wallet>;
